import { render, staticRenderFns } from "./HistoryFiguresWidget.vue?vue&type=template&id=f2b229e2&"
import script from "./HistoryFiguresWidget.vue?vue&type=script&lang=js&"
export * from "./HistoryFiguresWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2b229e2')) {
      api.createRecord('f2b229e2', component.options)
    } else {
      api.reload('f2b229e2', component.options)
    }
    module.hot.accept("./HistoryFiguresWidget.vue?vue&type=template&id=f2b229e2&", function () {
      api.rerender('f2b229e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/HistoryFiguresWidget.vue"
export default component.exports